import s from '../../styles/components/menu/MenuSections.module.css';

const MAX_PER_SIDE = 4;

function buildBlocks(items) {
  const featured = items.filter((i) => i.image);
  const regular = items.filter((i) => !i.image);

  if (!featured.length) return [{ featured: null, items: regular.slice(0, MAX_PER_SIDE * 2) }];

  const perBlock = Math.min(Math.ceil(regular.length / featured.length), MAX_PER_SIDE);

  return featured.map((f, i) => ({
    featured: f,
    items: regular.slice(i * perBlock, (i + 1) * perBlock),
  }));
}

export default function MenuSections({ menu, wide, hovered, onHover }) {
  let blockCounter = 0;
  const isFeaturedLeft = (n) => n % 2 === 0;

  return (
    <>
      {menu.sections.map((sec, si) => {
        const blocks = buildBlocks(sec.items);
        return (
          <div key={sec.id} className={si === 0 ? s.sectionFirst : s.section}>
            <div className={s.sectionHead}>
              <h3 className={s.sectionName}>{sec.name}</h3>
              <span className={s.sectionRule} />
            </div>

            {blocks.map((block, bi) => {
              const featuredLeft = isFeaturedLeft(blockCounter);
              blockCounter += 1;
              const f = block.featured;

              return (
                <div
                  key={f ? f.id : `block-${bi}`}
                  className={`${s.block} ${wide && f ? s.blockWide : s.blockNarrow}`}
                >
                  {f && (
                    <article
                      onMouseEnter={() => onHover(f.id)}
                      onMouseLeave={() => onHover(null)}
                      className={s.featured}
                      style={{ gridColumn: wide ? (featuredLeft ? 1 : 2) : 1, gridRow: 1 }}
                    >
                      <img
                        src={f.image}
                        alt={f.imageAlt || f.name}
                        className={`${s.featuredImage} ${hovered === f.id ? s.featuredImageHover : ''}`}
                      />
                      <div className={s.featuredScrim} />
                      <div className={s.featuredBody}>
                        <span className={s.featuredBadge}>Featured</span>
                        <h4 className={s.featuredName}>{f.name}</h4>
                        <p className={s.featuredDescription}>{f.description}</p>
                        {f.price && <span className={s.featuredPrice}>{f.price}</span>}
                      </div>
                    </article>
                  )}

                  <div
                    className={wide && f ? s.list : s.listNarrow}
                    style={{
                      gridTemplateRows: wide && f ? `repeat(${block.items.length}, 1fr)` : 'auto',
                      gridColumn: wide && f ? (featuredLeft ? 2 : 1) : 1,
                      gridRow: wide && f ? 1 : 2,
                    }}
                  >
                    {block.items.map((item, i) => (
                      <article
                        key={item.id}
                        className={`${s.listItem} ${i === block.items.length - 1 ? s.listItemLast : ''}`}
                      >
                        <h4 className={s.itemName}>{item.name}</h4>
                        <p className={s.description}>{item.description}</p>
                        {item.price && <span className={s.price}>{item.price}</span>}
                      </article>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}